export function waitingStateLabelKey(status) {
  return status === "live" ? "call.waiting" : "call.connecting"
}
